import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row } from 'components/common/FormElements/FormStyles'
import { Input } from 'components/common/FormElements/Input'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'

const ShowHidePasswordField = ({ className, changeType, blurType, ...props }) =>
  <Row relative className={ className }>
    <Col>
      <Input msHideCross { ...props } onBlur={ blurType } />
      <ShowHidePasswordButton
        data-at-showhidepassword
        hidden={ !props.meta.active }
        link
        bolder
        prevent
        changeType={ changeType }>
        <span data-sr-only>Password </span>{ props.type === 'password' ? 'Show' : 'Hide' }
      </ShowHidePasswordButton>
    </Col>
  </Row>

ShowHidePasswordField.propTypes = {
  blurType: PropTypes.func,
  changeType: PropTypes.func,
  className: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string
  }),
  meta: PropTypes.shape({
    active: PropTypes.bool
  }),
  type: PropTypes.string
}

export default ShowHidePasswordField

const ShowHidePasswordButton = styled(Button).attrs(({
  prevent,
  changeType
}) => ({
  onClick: (e) => {
    prevent && e.preventDefault()
    changeType && changeType()
  }
}))`
  position: absolute;
  top: 0;
  right: 10px;
  color: ${Theme.colors.blue};

  @supports (-webkit-appearance:none) and (stroke-color:transparent) {
    right: 25px !important;
  }

  ${Mixin.font.GothamBold(14)}
`
const Col = styled.div`
  width: 18em;
  position: relative;
`
